import { useCustomerInformationStore } from '../components/checkout/stores/customerInformationStore';
import { useDeliveryInformationStore } from '../components/checkout/stores/deliveryInformationStore';
import { CheckoutStep, CheckoutSteps } from './models/checkout.models';

/**
 * Policy definition for a single checkout step.
 * Encapsulates validation and side effects specific to each step.
 */
export type CheckoutStepPolicy = {
  validate: () => Promise<boolean>;
  onEnter?: () => Promise<void>;
};

/**
 * Step policy registry: maps each active checkout step to its validation policy.
 * Centralizes per-step rules and makes it easy to extend or modify step behavior.
 *
 * To add a new step policy:
 * 1. Add entry here mapping step to its validator
 * 2. Implement the validator with appropriate validation logic
 * 3. Update CheckoutStepOrder in checkout.models.ts if adding a new step
 */
export const checkoutStepPolicies: Partial<Record<CheckoutStep, CheckoutStepPolicy>> = {
  [CheckoutSteps.CustomerInformation]: {
    validate: async () => {
      return await useCustomerInformationStore().submitForm();
    },
  },
  [CheckoutSteps.Delivery]: {
    validate: async () => {
      return await useDeliveryInformationStore().submitForm();
    },
    onEnter: async () => {
      await useDeliveryInformationStore().loadDeliveryInformation();
    },
  },
};
